<template>
	<div class="CarouselContainer" @mouseenter="stopAutoPlay" @mouseleave="startAutoPlay">
		<div ref="mySwiper193" class="swiper-container swiper-container193" :id="'currentSwiper'+currentIndex"
			v-if="type===3">
			<div class="swiper-wrapper">
				<div class="swiper-slide" v-for="(item,index) of data" :key="index">
					<div>
						<img :src="item.url" /><br />
					</div>
				</div>
			</div>
		</div>
		<div v-else ref="mySwiper2" class="swiper-container1" :id="'currentSwiper'+currentIndex">
			<div class="swiper-wrapper">
				<div class="swiper-slide my-swiper-slide1" v-for="(item,index) of data" :key="index">
					<div class="swiperSlide text-center">
						<img class="smallImg" :src="item.img" /><br />
						<img :src="item.url" /><br />
						<h2>{{item.name}}</h2>
						<p>{{item.text}}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Swiper from 'swiper'
	import "swiper/css/swiper.css";
	export default {
		name: 'CarouselContainer',
		props: ['slideList', 'currentIndex', 'type'],
		data() {
			return {
				currentSwiper: null,
				data: null,
				data2: [
					// {url:require('../assets/swiperImg/watch1.png'),name:'AF3 4G双模智能手表',text:'ECG 心电检测，4PD动态心率血氧传感器和体温监测'},
					// {url:require('../assets/swiperImg/watch2.png'),name:'AF3 4G双模智能手表',text:'ECG 心电检测、动态心率、血氧、血压趋势和体温监测'},
					// {url:require('../assets/swiperImg/watch3.png'),name:'4G气泵血压智能手表',text:'4G款血压，随时随地，精准测量，无需配对手机，数据直传后台，方便健康管理服务'},
					// {url:require('../assets/swiperImg/watch4.png'),name:'L18 4G智能手表',text:'ECG 心电检测，4PD动态心率血氧传感器和体温监测'},
					// {url:require('../assets/swiperImg/watch5.png'),name:'GT3 4G智能手表',text:'4G高性价比，性能稳定，出货量大，民政集采爆款'},
					{
						url: require('../assets/endowment/end1.png'),
						name: '智能健康手表 MF5',
						text: '智能双模/跌倒定位/心脏健康/睡眠健康'
					}, {
						url: require('../assets/endowment/end2.png'),
						name: '智能健康手表 MF1',
						text: '全方位守护，给您贴心保护'
					}, {
						url: require('../assets/endowment/end3.png'),
						name: '智能健康手表 MF2',
						text: '高清AMOLED大屏+视频通话'
					}, {
						url: require('../assets/endowment/end4.png'),
						name: '智能健康手表 MF3',
						text: '医疗级测血压心率手表'
					}, {
						url: require('../assets/endowment/end5.png'),
						name: '智能健康手表 MF6',
						text: '高清AMOLED大屏+陶瓷机身'
					}, {
						url: require('../assets/endowment/end6.png'),
						name: '智能健康手表 MF9',
						text: '高清AMOLED大屏+健康管理服务'
					},
				],
				data1: [{
					url: require('../assets/endowment/end1.png'),
					name: '智能健康手表 MF5',
					text: '智能双模/跌倒定位/心脏健康/睡眠健康'
				}, {
					url: require('../assets/endowment/end2.png'),
					name: '智能健康手表 MF1',
					text: '全方位守护，给您贴心保护'
				}, {
					url: require('../assets/endowment/end3.png'),
					name: '智能健康手表 MF2',
					text: '高清AMOLED大屏+视频通话'
				}, {
					url: require('../assets/endowment/end4.png'),
					name: '智能健康手表 MF3',
					text: '医疗级测血压心率手表'
				}, {
					url: require('../assets/endowment/end5.png'),
					name: '智能健康手表 MF6',
					text: '高清AMOLED大屏+陶瓷机身'
				}, {
					url: require('../assets/endowment/end6.png'),
					name: '智能健康手表 MF9',
					text: '高清AMOLED大屏+健康管理服务'
				}, ],
				data3: [{
					url: require('../assets/endowment/img7.png'),
					name: 'AF3 4G 双模智能手表',
					text: 'ECG 心电检测，4PD动态心率血氧传感器和体温监测'
				}, {
					url: require('../assets/endowment/img8.png'),
					name: 'AF3 4G双模智能手表',
					text: 'ECG 心电检测、动态心率、血氧、血压趋势和体温监测'
				}, {
					url: require('../assets/endowment/img9.png'),
					name: '4G气泵血压智能手表',
					text: '4G款血压，随时随地，精准测量，无需配对手机，数据直传后台，方便健康管理服务'
				}, {
					url: require('../assets/endowment/img10.png'),
					name: 'L18 4G智能手表',
					text: 'ECG 心电检测，4PD动态心率血氧传感器和体温监测'
				}, {
					url: require('../assets/endowment/img15.png'),
					name: 'GT3 4G智能手表',
					text: '4G高性价比，性能稳定，出货量大，民政集采爆款'
				}, {
					url: require('../assets/endowment/img16.png'),
					name: 'L16智能手表',
					text: '4G智能通话手环，健康监测，定位SOS，简洁轻巧'
				}, {
					url: require('../assets/endowment/img17.png'),
					name: 'L16智能手表',
					text: '4G智能通话手环，健康监测，定位SOS，简洁轻巧'
				}, ],
				data4: [{
					img: require('../assets/xintai/watch0.png'),
					url: require('../assets/xintai/watch1.png'),
					name: '华为擎云 H5546',
				}, {
					img: require('../assets/xintai/watch0.png'),
					url: require('../assets/xintai/watch2.png'),
					name: '华为WATCH B9-D10',
				}, {
					img: require('../assets/xintai/watch0.png'),
					url: require('../assets/xintai/watch3.png'),
					name: '华为擎云 H7546',
				}, {
					img: require('../assets/xintai/watch0.png'),
					url: require('../assets/xintai/watch4.png'),
					name: '华为擎云 HA580',
				}, {
					img: require('../assets/xintai/watch.png'),
					url: require('../assets/xintai/watch5.png'),
					name: '心泰 MF2',
				}, ],
			}
		},
		mounted() {
			if (this.type == 1) {
				this.data = this.data1
			} else if (this.type == 3) {
				this.data = this.data3
			} else if (this.type == 4) {
				this.data = this.data4
			} else {
				this.data = this.data2
			}
			this.$nextTick(() => {
				this.initSwiper()
			})
		},
		methods: {
			//鼠标移入暂停自动播放
			stopAutoPlay() {
				this.currentSwiper.autoplay.stop()
			},
			//鼠标移出开始自动播放
			startAutoPlay() {
				this.currentSwiper.autoplay.start()
			},
			//初始化swiper
			initSwiper() {
				// eslint-disable-next-line
				let that = this //获取vue组件实例
				//一个页面有多个swiper实例时，为了不互相影响,绑定容器用不同值或变量绑定
				this.currentSwiper = new Swiper('#currentSwiper' + this.currentIndex, {
					loop: false, // 循环模式选项
					autoHeight: 'true', //开启自适应高度,容器高度由slide高度决定
					//分页器
					pagination: {
						el: '.swiper-pagination',
						clickable: true, //分页器按钮可点击
					},
					on: {
						//此处this为swiper实例
						//切换结束获取slide真实下标
						slideChangeTransitionEnd: function() {
							// console.log(vueComponent.$props.currentIndex+"号swiper实例真实下标",this.realIndex)
						},
						//绑定点击事件,解决loop:true时事件丢失
						// eslint-disable-next-line
						click: function(event) {
							// console.log("你点击了"+vueComponent.$props.currentIndex+"号swiper组件")
						}
					},
					//导航器
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					autoplay: {
						//自动播放,不同版本配置方式不同
						delay: 3000,
						stopOnLastSlide: false,
						disableOnInteraction: false
					},
					slidesPerView: that.type == '1' || that.type == '2' ? 6 : that.type == '3' ? 4 : 5, //视口展示slide数1,5
					spaceBetween: that.type == '1' || that.type == '2' ? 100 : 20,
					slidesPerGroup: 1, //slide数1页一组
				})
			},
			//销毁swiper
			destroySwiper() {
				try {
					this.currentSwiper.destroy(true, false)
				} catch (e) {
					// console.log("删除轮播")
				}
			},
			//更新swiper
			updateSwiper() {
				// this.destroySwiper()
				this.$nextTick(() => {
					this.initSwiper()
				})
			},
		},
		destroyed() {
			this.destroySwiper()
		}
	}
</script>
<style scoped>
	#currentSwiper4 {
		.swiper-slide {
			justify-content: center;
		}
		.swiper-slide,
		.swiperSlide {
			background: #F6F8FC;
		}
	}

	.my-swiper-slide {
		display: flex;
		align-content: center;
		justify-content: center;
	}

	.slideItem {
		height: 300px;
		background: #FFFFFF;
		box-shadow: 0px 10px 40px 0px rgba(0, 25, 80, 0.1);
		border-radius: 10px;
		font-size: 16px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
		line-height: 22px;
		position: relative;
		padding: 50px;
		margin: 0 60px;
	}

	.slideItem p {
		max-width: 50%;
	}

	.slideItem h1 {
		font-size: 30px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #000000;
		line-height: 42px;
	}

	.slideItem img {
		height: 440px;
		position: absolute;
		right: 0;
		top: -22%;
	}

	.CarouselContainer {}

	/*slide样式*/
	.my-swiper-slide {
		/*height: 640px;*/
	}

	/*swiper容器样式*/
	.swiper-container193 {
		width: 57%;
		margin: 0 auto 0 0;
		height: 193px;
	}

	.swiper-container1 {
		width: 100%;
	}

	.swiper-container3 {
		width: 700px;
		height: 650px;
	}

	.swiper-container4 {
		width: 100%;
		margin: 80px 0;
	}

	.my-swiper-slide1 {
		height: 400px;
		display: flex;
		align-items: center;
	}

	.swiperSlide {
		background: #ffffff;
		/*margin: 0 10px;*/
		height: 320px;
	}

	.swiperSlide img {
		height: 180px;
	}

	.smallImg {
		height: 36px !important;
		margin-bottom: 10px;
	}

	.swiperSlide h2 {
		font-size: 18px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #333333;
		line-height: 25px;
		margin: 20px 0 14px 0;
		padding: 0 20px;
	}

	.swiperSlide p {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #91909A;
		line-height: 20px;
		padding: 0 20px;
	}

	.swiper-pagination {
		margin-top: 20px;
		padding: 20px 0 0 0;
		background: #F3F5FA;
		border-radius: 49px;
	}

	/*!*自定义分页器按钮被点击选中时的样式*!*/
	/deep/.swiper-pagination-bullet-active {
		background: #f0ad4e;
		width: 66px;
		height: 66px;
		border: 4px solid #76ABFF !important;
	}

	/deep/.swiper-pagination-bullet {
		opacity: 1;
		border: 4px solid #ffffff;
		width: 66px;
		height: 66px;
	}

	/*自定义分页器按钮常规样式*/
	/deep/.swiper-pagination-bullet:nth-child(1) {
		background: url("../assets/swiperImg/hd1.png");
	}

	/deep/.swiper-pagination-bullet:nth-child(2) {
		background: url("../assets/swiperImg/hd2.png");
	}

	/deep/.swiper-pagination-bullet:nth-child(3) {
		background: url("../assets/swiperImg/hd3.png");
	}

	/deep/.swiper-pagination-bullet:nth-child(4) {
		background: url("../assets/swiperImg/hd4.png");
	}

	/deep/.swiper-pagination-bullet:nth-child(5) {
		background: url("../assets/swiperImg/hd5.png");
	}

	/deep/.swiper-pagination-bullet:nth-child(6) {
		background: url("../assets/swiperImg/hd6.png");
	}

	/deep/.swiper-pagination-bullet:nth-child(7) {
		background: url("../assets/swiperImg/hd7.png");
	}

	/deep/.swiper-pagination-bullet:nth-child(8) {
		background: url("../assets/swiperImg/hd8.png");
	}
</style>